export const openSourceFilters = [
  // {
  //   text: "Discuss Coding Sheets",
  //   id: 0,
  // lock: true,
  // },
  {
    text: "Beginner Swags",
    domainFilter: "swags",
    id: 1,
    lock: false,
  },
  {
    text: "Hiring",
    domainFilter: "hiring",
    id: 2,
    lock: false,
  },
  {
    text: "Bounties",
    domainFilter: "bounties",
    id: 3,
    lock: false,
  },
  {
    text: "Communities",
    domainFilter: "communities",
    id: 4,
    lock: true,
  },
  {
    text: "Personal Mentorship",
    domainFilter: "personal-mentorship",
    id: 5,
    lock: true,
  },
];
